import { render, staticRenderFns } from "./Pupil.vue?vue&type=template&id=bd868b70&scoped=true"
import script from "./Pupil.vue?vue&type=script&lang=js"
export * from "./Pupil.vue?vue&type=script&lang=js"
import style0 from "./Pupil.vue?vue&type=style&index=0&id=bd868b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd868b70",
  null
  
)

export default component.exports